import { render, staticRenderFns } from "./SilenciarFornecedor.vue?vue&type=template&id=4e1c5ec0"
import script from "./SilenciarFornecedor.vue?vue&type=script&lang=js"
export * from "./SilenciarFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports